var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 121,
    viewBox: "0 0 93 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_1638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7315 47.4827H13.9596V32.4748C13.9596 14.6194 28.5542 0.0844727 46.4882 0.0844727C64.4222 0.0844727 79.0168 14.6194 79.0168 32.4748V47.4827H79.2214C86.8245 47.4827 93 53.6085 93 61.1792V106.386C93 113.935 86.8245 120.082 79.2214 120.082H13.7315C6.14967 120.082 0 113.935 0 106.386V61.1792C0 53.6085 6.15202 47.4827 13.7315 47.4827ZM66.8045 32.4748C66.8045 21.3306 57.6799 12.2449 46.4882 12.2449C35.2965 12.2449 26.1955 21.3306 26.1955 32.4748V47.4827H66.8045V32.4748ZM46.4882 98.0599C53.0941 98.0599 58.4278 92.7489 58.4278 86.1711C58.4278 79.5933 53.0941 74.2823 46.4882 74.2823C39.8823 74.2823 34.5487 79.5933 34.5487 86.1711C34.5487 92.7489 39.8823 98.0599 46.4882 98.0599Z",
    fill: "url(#paint0_linear_727_1638)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_727_1638",
    x1: 46.5,
    y1: 0.0844727,
    x2: 46.5,
    y2: 120.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC76B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_1638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 120,
    fill: "white",
    transform: "matrix(-1 0 0 1 93 0.0844727)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.a01aaec875e56a37caee3ec2176af200.svg";
export { ForwardRef as ReactComponent };